export const GRIDEABLE_REQUEST = 'GRIDEABLE_REQUEST';
export const GRIDEABLE_SUCCESS = 'GRIDEABLE_SUCCESS';
export const GRIDEABLE_FAILURE = 'GRIDEABLE_FAILURE';
export const GRIDEABLE_SEARCH = 'GRIDEABLE_SEARCH';
export const GRIDEABLE_SET_SEARCH_FIELDS = 'GRIDEABLE_SET_SEARCH_FIELDS';
export const GRIDEABLE_SET_TIENDA_ID_FILTER = 'GRIDEABLE_SET_TIENDA_ID_FILTER';
export const GRIDEABLE_SET_ORDER = 'GRIDEABLE_SET_ORDER';
export const GRIDEABLE_INIT = 'GRIDEABLE_INIT';

